module.exports = __webpack_public_path__ + "media/mosaics/Mosaic-Focus-2-094d497d.png";